const mobilePopup = document.querySelector(".mobile-popup");
const mobilePopupIcon = document.querySelector(".mobile-popup__icon");

const hideBody = () => {
  $("body").addClass("hidden");
  $("html").addClass("hidden");
};

const showBody = () => {
  $("body").removeClass("hidden");
  $("html").removeClass("hidden");
};

mobilePopup.addEventListener("click", () => openPopup(), { once: true });
mobilePopupIcon.addEventListener("click", () => closePopup());

const openPopup = () => {
  if (!mobilePopup.classList.contains("active")) {
    mobilePopup.classList.add("active");
    $(".header").addClass("hidden");
    hideBody();
  }
};

const closePopup = () => {
  if (mobilePopup.classList.contains("active")) {
    mobilePopup.classList.remove("active");
    $(".header").removeClass("hidden");
    showBody();

    setTimeout(
      () =>
        mobilePopup.addEventListener("click", () => openPopup(), {
          once: true,
        }),
      100
    );
  }
};
